import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3d57bdc6&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/navbar.css?vue&type=style&index=0&id=3d57bdc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57bdc6",
  null
  
)

export default component.exports